import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Text, StyledCard, StyledCardContent, IconButton, EditIcon } from '../../index';

export const RulesCard = ({ data, onEdit, disabled }) => {
    return !_.isEmpty(data) ? (
        <StyledCard padding="20px">
            <StyledCardContent>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '15px',
                    }}
                >
                    <Text $fontSize="18px" $bold>
                        Rules & Condition
                    </Text>
                    {!disabled && onEdit && (
                        <IconButton onClick={onEdit} disabled={disabled}>
                            <EditIcon width="16px" height="16px" fill="black" />
                        </IconButton>
                    )}
                </div>

                <div style={{ marginTop: '15px' }}>
                    {data.map((item, index) => (
                        <div
                            key={item.id}
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '15px auto',
                                columnGap: '5px',
                            }}
                        >
                            <Text $color="gray2" $fontSize="12px">{`${index + 1}.`}</Text>
                            <Text $color="gray2" $fontSize="12px">
                                {item.text}
                            </Text>
                        </div>
                    ))}
                </div>
            </StyledCardContent>
        </StyledCard>
    ) : (
        <Fragment></Fragment>
    );
};

RulesCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onEdit: PropTypes.func,
    disabled: PropTypes.bool,
};
